import React, { useEffect, useMemo, useState } from "react";

function Logo() {
  return (
    <a href="#top" className="logoWrap" aria-label="Seasons Flavours Fragrance home">
      <span className="logoMark" aria-hidden="true">S</span>
      <span className="logoText">
        <span className="logoTop">Seasons</span>
        <span className="logoBottom">Flavours Fragrances</span>
      </span>
    </a>
  );
}

const links = [
  { href: "#about", label: "About" },
  { href: "#products", label: "Products" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  // Close menu on hash change / scroll
  useEffect(() => {
    const onHash = () => setOpen(false);
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const navLinks = useMemo(() => (
    links.map((l) => (
      <a key={l.href} className="navLink" href={l.href} onClick={() => setOpen(false)}>
        {l.label}
      </a>
    ))
  ), []);

  return (
    <header className="siteHeader" id="top">
      <div className="container headerRow">
        <Logo />

        <nav className="nav" aria-label="Primary navigation">
          {navLinks}
        </nav>

        <div className="headerRight">
          <a className="btn primary desktopOnly" href="#contact">Get a Quote</a>

          <button
            type="button"
            className="hamburger mobileOnly"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open ? "true" : "false"}
            onClick={() => setOpen((v) => !v)}
          >
            <span className="hamburgerLines" aria-hidden="true" />
          </button>
        </div>
      </div>

      <div className={open ? "mobileMenu open" : "mobileMenu"} role="dialog" aria-label="Mobile menu">
        <div className="container mobileMenuInner">
          <div className="mobileMenuTop">
            <div className="pill">Menu</div>
            <button className="btn" type="button" onClick={() => setOpen(false)}>Close</button>
          </div>
          <div className="mobileLinks">
            {navLinks}
            <a className="btn primary" href="#contact" onClick={() => setOpen(false)}>Get a Quote</a>
          </div>
        </div>
      </div>
    </header>
  );
}
